module.exports = __webpack_public_path__ + "img/MaskGroup(1).9d811d9b.png";